import React from 'react';

const LoadingScreen: React.FC = () => (
  <div className="flex justify-center items-center h-screen bg-gradient-to-r from-blue-500 to-purple-600">
    <div className="text-white text-center">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white mx-auto mb-4"></div>
      <h2 className="text-2xl font-semibold">Loading Meal Tracker</h2>
      <p className="mt-2">Preparing your nutritional journey...</p>
    </div>
  </div>
);

export default LoadingScreen;
